/* src/app/modules/invoice/invoice/invoice-dialog-verifactu.component.css */
.vf-header-text {
  min-width: 0;
  padding-right: 32px;
}
.vf-qr {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px;
  background: #f4f6f8;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  margin-bottom: 20px;
}
.vf-qr img {
  width: 140px;
  height: 140px;
}
.vf-qr__label {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  text-align: center;
}
.vf-section__hdr {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #1a1d23;
  margin-bottom: 12px;
}
.vf-section__hdr mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #6b7280;
}
.vf-events {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  border-left: 2px solid #e5e7eb;
  padding-left: 16px;
}
.vf-events__item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  font-size: 13px;
  color: #374151;
  position: relative;
  margin-left: -21px;
  padding-left: 21px;
  list-style: none;
}
.vf-events__dot {
  flex-shrink: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e3fd64;
  border: 2px solid #fff;
  outline: 2px solid #e3fd64;
  margin-top: 3px;
  position: absolute;
  left: -5px;
}
.vf-events__text {
  line-height: 1.5;
}
.vf-empty {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #6b7280;
  padding: 12px;
  background: #f4f6f8;
  border-radius: 6px;
  margin: 0;
}
.vf-empty mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #9ca3af;
}
.vf-events__more {
  display: block;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: none;
  color: var(--cf-brand-dark);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.vf-events__detail {
  display: block;
  margin-top: 6px;
  padding: 8px 10px;
  border-radius: 6px;
  background: #f4f6f8;
  color: var(--cf-text-muted);
  font-size: 11px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}
/*# sourceMappingURL=invoice-dialog-verifactu.component.css.map */
